import * as THREE from "three"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
gsap.registerPlugin(ScrollTrigger)

import { loaders, scene, camera, pane, deviceStateManager } from "./Experience"

import overlayCircleVertexShader from "../../shaders/overlay/vertex.glsl"
import overlayCircleFragmentShader from "../../shaders/overlay/fragment.glsl"

export class Overlay {
  constructor() {
    // this.overlay = document.querySelector(".overlay")
    this.mouse = {}

    this.setOverlay()
  }

  setOverlay() {
    const geometry = new THREE.CircleGeometry(0.03, 64)
    // const material = new THREE.MeshBasicMaterial({
    //   side: THREE.FrontSide,
    //   colorWrite: false,
    //   depthWrite: false,
    //   stencilWrite: true,
    //   stencilFunc: THREE.AlwaysStencilFunc,
    //   stencilRef: 1,
    //   stencilFail: THREE.KeepStencilOp,
    //   stencilZFail: THREE.KeepStencilOp,
    //   stencilZPass: THREE.IncrementWrapStencilOp,
    // })
    const material = new THREE.ShaderMaterial({
      vertexShader: overlayCircleVertexShader,
      fragmentShader: overlayCircleFragmentShader,
      uniforms: { uTime: { value: 0 } },

      colorWrite: false,
      depthWrite: false,
      stencilWrite: true,
      stencilFunc: THREE.AlwaysStencilFunc,
      stencilRef: 1,
      stencilFail: THREE.KeepStencilOp,
      stencilZFail: THREE.KeepStencilOp,
      stencilZPass: THREE.IncrementWrapStencilOp,
    })
    this.overlay = new THREE.Mesh(geometry, material)
    this.overlay.renderOrder = 4
    scene.add(this.overlay)

    this.overlayOutline = new THREE.Mesh(
      new THREE.RingGeometry(0.03, 0.0302, 64, 1),
      // new THREE.MeshBasicMaterial({ color: "#fff" })
      new THREE.ShaderMaterial({
        vertexShader: overlayCircleVertexShader,
        fragmentShader: overlayCircleFragmentShader,
        uniforms: { uTime: { value: 0 } },
        transparent: true,
      })
    )
    scene.add(this.overlayOutline)
  }

  connectOverlayWithMouse() {
    //Check for device states
    if (deviceStateManager.state === "mobile") {
      this.overlay.position.set(0, 0.8, 1.5)
      this.overlay.scale.set(10, 10, 10)
      this.overlayOutline.visible = false
    } else {
      document.addEventListener("mousemove", (event) => {
        // console.log("Moving Mouse!")

        // Update the mouse variable
        event.preventDefault()
        this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1
        this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1
      })
    }
  }

  update(elapsedTime) {
    this.overlay.material.uniforms.uTime.value = elapsedTime
    this.overlayOutline.material.uniforms.uTime.value = elapsedTime
    // this.overlay.children[1].rotation.z += 0.01

    if (deviceStateManager.state !== "mobile") {
      // Make the sphere follow the mouse
      let vector = new THREE.Vector3(this.mouse.x, this.mouse.y, 0.5)
      vector.unproject(camera.camera)
      let dir = vector.sub(camera.camera.position).normalize()
      let distance = -camera.camera.position.z / dir.z
      let pos = camera.camera.position
        .clone()
        .add(dir.multiplyScalar(distance * 0.05))
      pos.z = 1.5

      let overlayTarget = this.overlay.position.lerp(pos, 0.2)
      this.overlay.position.set(overlayTarget.x, overlayTarget.y, 1.5)
      this.overlayOutline.position.set(overlayTarget.x, overlayTarget.y, 1.5)
    }
  }
}
